<template>
</template>

<script>
  export default {
    data() {
      return{}
    },
    created() {
      this.$router.push('/device')
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/Index.vue